import { createApiSlice } from "@common";
import {
  CRUD_API_TOKEN,
  GET_API_TOKEN_BY_INTEGRATION
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addApiToken",
    method: "post",
    url: CRUD_API_TOKEN,
    stateKey: "message",
  },
  {
    name: "getApiTokenByIntegration",
    method: "get",
    url: GET_API_TOKEN_BY_INTEGRATION,
    stateKey: "data",
  },
  {
    name: "updateApiToken",
    method: "put",
    url: CRUD_API_TOKEN,
    stateKey: "message",
  },
  {
    name: "deleteApiToken",
    method: "delete",
    url: CRUD_API_TOKEN,
    stateKey: "message",
  },
  {
    name: "updateApiTokenStatus",
    method: "patch",
    url: `${CRUD_API_TOKEN}/update_status`,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    keyData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "apiToken",
  apiConfig,
  customReducers,
);
const apiTokenSlice = slice;
// Export the slice's reducer
export default apiTokenSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addApiToken,
  getApiTokenByIntegration,
  updateApiToken,
  deleteApiToken,
  updateApiTokenStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
